import React from 'react';
import { XIcon } from 'lucide-react';
import { PAIN_BODY, PAIN_CLOSING, PAIN_EMPHASIS, PAIN_HEADLINE, painLines } from '../data/sushiContent';
export function PainSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="pain-title" data-id="element-230" data-mp="2uyov3q0ru9zw">
      <div className="mx-auto max-w-5xl px-5" data-id="element-231" data-mp="2yyz8hnqw82os">
        <h2 id="pain-title" className="max-w-3xl font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-232" data-mp="2z1tuvktgvxku">
          {PAIN_HEADLINE}
        </h2>

        {PAIN_BODY.map(line => <p key={line} className="mt-4 max-w-2xl text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-233" data-mp="2bb7odxz42lcy">
            {line}
          </p>)}

        <p className="mt-4 max-w-2xl text-[14px] leading-relaxed text-ivory-100 sm:text-[15px]" data-id="element-234" data-mp="228yglfv89639">
          {PAIN_EMPHASIS}
        </p>

        <ul className="mt-8 grid gap-x-10 border-t border-charcoal-600 sm:grid-cols-2" data-id="element-235" data-mp="2781m11f4debr">
          {painLines.map(line => <li key={line} className="flex items-start gap-3 border-b border-charcoal-600 py-4" data-id="element-236" data-mp="3rovfr1f5eqcb">
              <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-rose-deep" strokeWidth={3} aria-hidden="true" data-id="element-237" data-mp="5g2kimsuzoor" />
              <span className="text-[14px] font-medium leading-snug text-ivory-100" data-id="element-238" data-mp="38wj6duq2uoso">
                {line}
              </span>
            </li>)}
        </ul>

        <p className="mt-8 max-w-2xl font-display text-lg italic leading-snug text-champagne sm:text-2xl" data-id="element-239" data-mp="33vd9dkpdwfdc">
          {PAIN_CLOSING}
        </p>
      </div>
    </section>;
}